export const handleOnSortChange = (currentParams, fetchDataFunction = null, field, order) => {
  const sort = { field, order };

  if (fetchDataFunction) {
    fetchDataFunction({
      ...currentParams,
      sort,
    });
  }
};
